<template>
  <div class="landing">
    <div class="bg-glow">
      <HeroTransportadora id="hero-transportadora"/>
      <SecaoProblema id="secao-problema"/>
      <SecaoSolucao id="secao-solucao"/>
      <SecaoDiferencial id="diferencial"/>
      <GanchoFinal id="gancho-final"/>
    </div>
  </div>
</template>

<script>
import HeroTransportadora from '../components/HeroTransportadora.vue';
import SecaoSolucao from '../components/SecaoSolucao.vue';
import GanchoFinal from '../components/GanchoFinal.vue';
import SecaoProblema from '../components/SecaoProblema.vue';
import SecaoDiferencial from '../components/SecaoDiferencial.vue';

export default {
  name: "LandingBase44",

  components: {
    HeroTransportadora,
    SecaoProblema,
    SecaoSolucao,
    SecaoDiferencial,
    GanchoFinal
  }
};
</script>

<style scoped>
  .landing {
    position: relative;
    background: radial-gradient(circle at bottom right, #0f172a, #020617);
    color: #ffffff;
    font-family: "Inter", sans-serif;
    overflow: hidden;
  }
  
  /* GLOW BACKGROUND */
  .bg-glow::before {
    content: "";
    position: absolute;
    top: -300px;
    left: -200px;
    width: 800px;
    height: 800px;
    background: radial-gradient(circle, rgba(34,197,139,0.18) 0%, transparent 70%);
    filter: blur(100px);
  }
  
  .bg-glow::after {
    content: "";
    position: absolute;
    top: 200px;
    right: -300px;
    width: 900px;
    height: 900px;
    background: radial-gradient(circle, rgba(16,185,129,0.12) 0%, transparent 70%);
    filter: blur(120px);
  }
</style>